<app-banner-alert 
    [showBannerNotification]="StepperData.showBannerNotification" 
    [showBannerInvoice]="StepperData.showBannerInvoice" 
    (emitClickResendButton)="resendNotificationButton(stepper)">
</app-banner-alert>

<mat-stepper class="vertical-stepper" #stepper orientation="vertical" [linear]="stepperIsLinear">

    <mat-step [completed]="isCompleted_step1">
        <ng-template matStepLabel>
            {{keyTranslate + '.stepLabel.product' | translate}}
        </ng-template>
        <ng-template matStepContent>
            <div [ngClass]="{'disabledStyle': applyDisabledStyle(StepperData.productReadOnly, productFormDisabled)}">
            <app-product-contract-form [data]="productData" (isCompleted)="isCompleted('isCompleted_step1',$event)" (emitFormProductData)="addProductFormData($event)"></app-product-contract-form>
            </div>
        </ng-template>
    </mat-step><!-- Step 1-->

    <mat-step [completed]="isCompleted_step2">
        <ng-template matStepLabel>
            {{keyTranslate + '.stepLabel.client' | translate}}
        </ng-template>
        <ng-template matStepContent>

            <div [ngClass]="{'disabledStyle': applyDisabledStyle(StepperData.clientReadOnly, productFormDisabled)}"  >
                <app-client-contract-form [data]="clientData" (isCompleted)="isCompleted('isCompleted_step2',$event)" (emitFormClientData)="addClientFormData($event)">
                </app-client-contract-form>
            </div>

            <div *ngIf="StepperData.clientData && StepperData.sendNotification">
                <div class="sendContract">
                    <app-client-notification-card (emitNotifyType)="notifyTypeEventHandler($event, stepper)">
                    </app-client-notification-card>
                </div>
            </div>

        </ng-template>
    </mat-step><!-- Step 2-->

    <mat-step>

        <ng-template matStepLabel>
            {{keyTranslate + '.stepLabel.payment' | translate}}
        </ng-template>

        <div [ngClass]="{'disabledStyle': applyDisabledStyle(StepperData.invoiceReadOnly)}">

            <app-pay-contract-form [finishButton]="finishButton" [data]="invoiceData"
                (emitFormInvoiceData)="addInvoiceFormData($event)">
            </app-pay-contract-form>

            <div *ngIf="invoiceData && cotizacion_autorizada" class="button-container" fxLayout="row"
                fxLayoutAlign="center center">
                <button [disabled]="!cotizacion_autorizada" (click)="contratar()">
                    {{ 'clientContracts.forms.payContractForm.textButton' | translate }}
                </button>
            </div>

        </div>

    </mat-step><!-- Step 3-->
</mat-stepper>